import { Box, MantineStyleProp } from '@mantine/core'
import { FC, useMemo } from 'react'

type Position =
  | 'left'
  | 'right'
  | 'center'
  | 'top-right'
  | 'top-left'
  | 'bottom-left'
  | 'bottom-right'
  | 'right-center'
  | 'left-center'

const determineControlBoxPosition = (position: Position) => {
  switch (position) {
    case 'left':
      return { left: 20 }
    case 'right':
      return { right: 20 }
    case 'center':
      return { top: 20, left: '50%', transform: 'translateX(-50%)' }
    case 'top-right':
      return { top: 20, right: 20 }
    case 'top-left':
      return { top: 20, left: 20 }
    case 'bottom-left':
      return { bottom: 20, left: 20 }
    case 'bottom-right':
      return { bottom: 20, right: 20 }
    case 'right-center':
      return { top: '50%', right: 20, transform: 'translateY(-50%)' }
    case 'left-center':
      return { top: '50%', left: 20, transform: 'translateY(-50%)' }
    default:
      return {}
  }
}

const MapControlBox: FC<{
  children: React.ReactNode
  position: Position
  top?: number
  style?: MantineStyleProp
}> = ({ children, position, top = 50, style }) => {
  const controlBoxPosition = useMemo(() => determineControlBoxPosition(position), [position])

  return (
    <Box
      style={{
        position: 'absolute',
        top: `${top}%`,
        // transform: 'translateY(-50%)',
        ...controlBoxPosition,
        zIndex: 1000,
        ...style,
      }}
    >
      {children}
    </Box>
  )
}

export default MapControlBox
